import React from 'react'
import { useSelector } from 'react-redux'
import { Breadcrumb } from 'react-breadcrumbs'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import { Link, Switch, Route, useLocation, useHistory } from 'react-router-dom'
import EditIcon from '@material-ui/icons/Edit'

import SubmitButton from '../../../../Components/Form/SubmitButton/index'
import { LocationsWrapper } from 'Components/City/Page/Locations/LocationsWrapper'
import CityPage from 'Containers/City/Page'

import { CAMPAIGN_ENUM_TYPES } from '../../../../shared/constants'
import CityLetterboxBuilder from '../../../CityLetterboxBuilder/CityLetterboxBuilder'
import StyledIconButton from '../../../../Components/Form/StyledIconButton'
import LocationsContainer from './Container/LocationsContainer'

const Locations = props => {
  const history = useHistory()
  const location = useLocation()
  const locationTypes = useSelector(state => state.locations.locationTypes)

  const getLocationTypeOptions = () => {
    const directMailLocationsOptions = []
    const handToHandLocationsOptions = []
    locationTypes.forEach(locationType => {
      if (locationType.name == 'Direct Mail') {
        directMailLocationsOptions.push({
          label: locationType.name,
          value: locationType.id,
        })
      } else
        handToHandLocationsOptions.push({
          label: locationType.name,
          value: locationType.id,
        })
    })
    return { directMailLocationsOptions, handToHandLocationsOptions }
  }

  const setType = type => {
    history.push(
      props.match.url +
        (type === CAMPAIGN_ENUM_TYPES.HANDTOHAND
          ? '/locations/handtohand'
          : type === CAMPAIGN_ENUM_TYPES.DIRECTMAIL
          ? '/locations/directmail'
          : '/locations/letterbox'),
    )
  }
  let activeButton
  const urlArray = location.pathname.split('/')
  const lastSegment = urlArray[urlArray.length - 1]
  if (lastSegment.toUpperCase() == CAMPAIGN_ENUM_TYPES.HANDTOHAND) {
    activeButton = CAMPAIGN_ENUM_TYPES.HANDTOHAND
  }
  if (lastSegment.toUpperCase() == CAMPAIGN_ENUM_TYPES.LETTERBOX) {
    activeButton = CAMPAIGN_ENUM_TYPES.LETTERBOX
  }
  if (lastSegment.toUpperCase() == CAMPAIGN_ENUM_TYPES.DIRECTMAIL) {
    activeButton = CAMPAIGN_ENUM_TYPES.DIRECTMAIL
  }
  const {
    directMailLocationsOptions,
    handToHandLocationsOptions,
  } = getLocationTypeOptions()
  return (
    <CityPage
      active={props.nav}
      cityId={props.cityId}
      history={props.history}
      className={props.className}
      match={props.match}
      cityName={props.cityName}
    >
      <Breadcrumb data={{ title: 'Locations', pathname: props.match.url }} />

      <Link to={props.match.url + '/edit'} className="link-edit-main">
        <StyledIconButton>
          <EditIcon />
        </StyledIconButton>
      </Link>
      <LocationsWrapper>
        <div className="type-buttons">
          <ButtonGroup disableElevation color="primary">
            <SubmitButton
              value="Hand to hand"
              variant={
                activeButton === CAMPAIGN_ENUM_TYPES.HANDTOHAND
                  ? 'contained'
                  : 'outlined'
              }
              onClick={() => setType(CAMPAIGN_ENUM_TYPES.HANDTOHAND)}
            />
            <SubmitButton
              value="Letterbox"
              variant={
                activeButton == CAMPAIGN_ENUM_TYPES.LETTERBOX
                  ? 'contained'
                  : 'outlined'
              }
              onClick={() => setType(CAMPAIGN_ENUM_TYPES.LETTERBOX)}
            />
            <SubmitButton
              value="Direct Mail"
              variant={
                activeButton == CAMPAIGN_ENUM_TYPES.DIRECTMAIL
                  ? 'contained'
                  : 'outlined'
              }
              onClick={() => setType(CAMPAIGN_ENUM_TYPES.DIRECTMAIL)}
            />
          </ButtonGroup>
        </div>
        <Switch>
          <Route
            exact
            path={props.match.url + '/locations/handtohand'}
            render={() => (
              <LocationsContainer
                {...props}
                locationTypeOptions={handToHandLocationsOptions}
              />
            )}
          />
          <Route
            exact
            path={props.match.url + '/locations/letterbox'}
            render={() => <CityLetterboxBuilder {...props} />}
          />
          <Route
            exact
            path={props.match.url + '/locations/directmail'}
            render={() => (
              <LocationsContainer
                {...props}
                isDM={true}
                locationTypeOptions={directMailLocationsOptions}
              />
            )}
          />
        </Switch>
      </LocationsWrapper>
    </CityPage>
  )
}

export default Locations



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Locations/unstyled.js